/* =========================================================
   PLANTS FOR ALL SEASONS
   LARGE PLANT DELIVERY SURCHARGE

   Trigger variants:
   Specific Shopify variant IDs listed below

   Surcharge variant:
   58683116978550

   Behaviour:
   - Any listed variant ID triggers surcharge
   - Adds ONE £4 surcharge per order
   - Multiple large plants still only incur one surcharge
   - Removes surcharge when last large plant is removed
   - Forces surcharge quantity to 1
   - Hides +/- controls on surcharge
   - Hides remove button on surcharge
   - Responds to Ella AJAX cart changes
========================================================= */

(function () {

  const SURCHARGE_VARIANT_ID = 58683116978550;
  const SURCHARGE_PRODUCT_HANDLE = 'large-plant-delivery-surcharge';

  const LARGE_PLANT_VARIANT_IDS = [
    56390573654390,
    56390573621622,
    56390585713014,
    56390620250486,
    56360921923958,
    56360901378422,
    56371392840054,
    56371359875446,
    56370985664886,
    56378655375734,
    56378650952054,
    56286894031222,
    56135656309110,
    57728098271606,
    56365418709366,
    56365451477366,
    58216153907574,
    
  ].map(String);

  let isSyncing = false;
  let syncQueued = false;
  let syncTimer = null;

  const root =
    (window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root)
      ? window.Shopify.routes.root
      : '/';


  /* =========================================================
     GET CART
  ========================================================= */

  async function getCart() {

    const response = await fetch(
      root + 'cart.js',
      {
        headers: {
          'Accept': 'application/json'
        },
        cache: 'no-store'
      }
    );

    if (!response.ok) {
      throw new Error(
        'Could not load Shopify cart'
      );
    }

    return await response.json();
  }


  /* =========================================================
     DOES CART CONTAIN A LARGE PLANT VARIANT?
  ========================================================= */

  function cartContainsLargePlant(cart) {

    return cart.items.some(function (item) {

      return (
        Number(item.variant_id) !== SURCHARGE_VARIANT_ID &&
        LARGE_PLANT_VARIANT_IDS.includes(
          String(item.variant_id)
        )
      );

    });
  }


  /* =========================================================
     ADD SURCHARGE
  ========================================================= */

  async function addSurcharge() {

    const response = await fetch(
      root + 'cart/add.js',
      {
        method: 'POST',

        headers: {
          'Content-Type':
            'application/json',
          'Accept':
            'application/json'
        },

        body: JSON.stringify({
          items: [
            {
              id:
                SURCHARGE_VARIANT_ID,
              quantity: 1
            }
          ]
        })
      }
    );


    if (!response.ok) {

      const error =
        await response.text();

      console.error(
        'PFAS surcharge could not be added:',
        error
      );

      return false;
    }

    return true;
  }


  /* =========================================================
     CHANGE SURCHARGE QUANTITY
  ========================================================= */

  async function changeSurchargeQuantity(
    surchargeItem,
    quantity
  ) {

    if (!surchargeItem) {
      return false;
    }


    const response = await fetch(
      root + 'cart/change.js',
      {
        method: 'POST',

        headers: {
          'Content-Type':
            'application/json',
          'Accept':
            'application/json'
        },

        body: JSON.stringify({
          id:
            surchargeItem.key,
          quantity:
            quantity
        })
      }
    );


    if (!response.ok) {

      console.error(
        'PFAS surcharge quantity could not be changed'
      );

      return false;
    }

    return true;
  }


  /* =========================================================
     LOCK SURCHARGE CONTROLS

     These selectors are based on the actual Ella
     cart markup on Plants for All Seasons.
  ========================================================= */

  function lockSurchargeControls() {


    /* -----------------------------------------------------
       FULL CART / ELLA QUANTITY CONTROL
    ----------------------------------------------------- */

    document.querySelectorAll(
      'cart-update-quantity' +
      '[data-variant="' +
      SURCHARGE_VARIANT_ID +
      '"]'
    ).forEach(
      function (quantityBlock) {


        /*
         * Hide Ella's complete
         * minus / input / plus block.
         */

        quantityBlock.style.setProperty(
          'display',
          'none',
          'important'
        );


        /*
         * Put a simple fixed "1"
         * in its place.
         */

        const parent =
          quantityBlock.parentElement;

        if (
          parent &&
          !parent.querySelector(
            '.pfas-fixed-surcharge-quantity'
          )
        ) {

          const fixedQuantity =
            document.createElement(
              'span'
            );

          fixedQuantity.className =
            'pfas-fixed-surcharge-quantity';

          fixedQuantity.textContent =
            '1';

          fixedQuantity.style.setProperty(
            'display',
            'inline-block'
          );

          fixedQuantity.style.setProperty(
            'min-width',
            '30px'
          );

          fixedQuantity.style.setProperty(
            'text-align',
            'center'
          );

          fixedQuantity.style.setProperty(
            'font-size',
            '16px'
          );

          quantityBlock
            .insertAdjacentElement(
              'afterend',
              fixedQuantity
            );
        }

      }
    );


    /* -----------------------------------------------------
       ELLA REMOVE BUTTON
    ----------------------------------------------------- */

    document.querySelectorAll(
      '[data-cart-remove-id="' +
      SURCHARGE_VARIANT_ID +
      '"]'
    ).forEach(
      function (removeButton) {

        removeButton.style.setProperty(
          'display',
          'none',
          'important'
        );

        removeButton.setAttribute(
          'aria-hidden',
          'true'
        );

        removeButton.setAttribute(
          'tabindex',
          '-1'
        );

      }
    );


    /* -----------------------------------------------------
       FALLBACK: FIND SURCHARGE PRODUCT LINKS

       Useful for Ella side-cart markup if it differs
       from the full cart.
    ----------------------------------------------------- */

    document.querySelectorAll(
      'a[href*="/products/' +
      SURCHARGE_PRODUCT_HANDLE +
      '"]'
    ).forEach(
      function (productLink) {

        let row =
          productLink.closest(
            '.previewCartItem'
          ) ||
          productLink.closest(
            '.cart-item'
          ) ||
          productLink.closest(
            '[data-cart-item]'
          ) ||
          productLink.closest(
            'li'
          );


        if (!row) {
          return;
        }


        /*
         * Hide quantity controls inside
         * the surcharge row.
         */

        row.querySelectorAll(
          'cart-update-quantity,' +
          '.quantity,' +
          '.quantity-item,' +
          '.previewCartItem-qty'
        ).forEach(
          function (control) {

            control.style.setProperty(
              'display',
              'none',
              'important'
            );

          }
        );


        /*
         * Hide obvious remove controls
         * inside surcharge row.
         */

        row.querySelectorAll(
          '[data-cart-remove],' +
          '.cart-remove,' +
          '.previewCartItem-remove'
        ).forEach(
          function (control) {

            control.style.setProperty(
              'display',
              'none',
              'important'
            );

          }
        );

      }
    );

  }


  /* =========================================================
     REFRESH ELLA CART DISPLAY
  ========================================================= */

  async function refreshEllaCart() {

    try {

      const cart =
        await getCart();


      /*
       * Ella side cart.
       */

      if (
        window.halo &&
        typeof window.halo
          .updateSidebarCart ===
          'function'
      ) {

        window.halo
          .updateSidebarCart(
            cart
          );
      }


      /*
       * Ella full cart.
       */

      if (
        window.halo &&
        typeof window.halo
          .updateCart ===
          'function'
      ) {

        window.halo
          .updateCart(
            cart
          );
      }


      /*
       * Ella may take a moment to
       * rebuild its HTML.
       */

      setTimeout(
        lockSurchargeControls,
        50
      );

      setTimeout(
        lockSurchargeControls,
        200
      );

      setTimeout(
        lockSurchargeControls,
        500
      );


      return cart;

    } catch (error) {

      console.error(
        'PFAS surcharge: could not refresh Ella cart',
        error
      );

      return null;
    }
  }


  /* =========================================================
     SYNC SURCHARGE
  ========================================================= */

  async function syncSurcharge() {


    /*
     * Don't allow multiple checks to
     * run over one another.
     */

    if (isSyncing) {

      syncQueued = true;

      return;
    }


    isSyncing = true;


    try {

      const cart =
        await getCart();


      const surchargeItem =
        cart.items.find(
          function (item) {

            return (
              Number(
                item.variant_id
              ) ===
              SURCHARGE_VARIANT_ID
            );

          }
        );


      const hasLargePlant =
        cartContainsLargePlant(
          cart
        );


      /* -----------------------------------------------------
         LARGE PLANT PRESENT,
         SURCHARGE MISSING
      ----------------------------------------------------- */

      if (
        hasLargePlant &&
        !surchargeItem
      ) {

        const added =
          await addSurcharge();

        if (added) {

          await refreshEllaCart();

        }

        return;
      }


      /* -----------------------------------------------------
         NO LARGE PLANTS,
         SURCHARGE STILL PRESENT
      ----------------------------------------------------- */

      if (
        !hasLargePlant &&
        surchargeItem
      ) {

        const removed =
          await changeSurchargeQuantity(
            surchargeItem,
            0
          );

        if (removed) {

          await refreshEllaCart();

        }

        return;
      }


      /* -----------------------------------------------------
         SURCHARGE QUANTITY MUST ALWAYS = 1
      ----------------------------------------------------- */

      if (
        hasLargePlant &&
        surchargeItem &&
        surchargeItem.quantity !== 1
      ) {

        const corrected =
          await changeSurchargeQuantity(
            surchargeItem,
            1
          );

        if (corrected) {

          await refreshEllaCart();

        }

        return;
      }


      /*
       * Everything is already correct.
       */

      lockSurchargeControls();


    } catch (error) {

      console.error(
        'PFAS Large Plant Delivery Surcharge:',
        error
      );


    } finally {

      isSyncing = false;


      if (syncQueued) {

        syncQueued = false;

        setTimeout(
          syncSurcharge,
          100
        );

      }

    }

  }


  /* =========================================================
     SCHEDULE A CART CHECK
  ========================================================= */

  function scheduleSync(delay) {

    clearTimeout(
      syncTimer
    );

    syncTimer =
      setTimeout(
        syncSurcharge,
        delay || 150
      );

  }


  /* =========================================================
     INITIAL PAGE LOAD
  ========================================================= */

  function initialiseSurcharge() {

    scheduleSync(200);

    setTimeout(
      lockSurchargeControls,
      300
    );

    setTimeout(
      lockSurchargeControls,
      700
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialiseSurcharge
    );

  } else {

    initialiseSurcharge();

  }


  /* =========================================================
     LISTEN FOR ELLA CART EVENTS
  ========================================================= */

  [
    'cart:refresh',
    'cart:updated',
    'cart:change',
    'cart:build',
    'ajaxProduct:added'
  ].forEach(
    function (eventName) {

      document.addEventListener(
        eventName,
        function () {

          scheduleSync(150);

          setTimeout(
            lockSurchargeControls,
            100
          );

        }
      );

    }
  );


  /* =========================================================
     WATCH SHOPIFY AJAX CART REQUESTS

     This is what lets us react when a product is
     added/removed through Ella's AJAX cart.
  ========================================================= */

  const originalFetch =
    window.fetch;


  window.fetch =
    async function () {

      const args =
        arguments;


      const response =
        await originalFetch.apply(
          this,
          args
        );


      try {

        const request =
          args[0];


        const url =
          typeof request ===
          'string'
            ? request
            : (
                request &&
                request.url
                  ? request.url
                  : ''
              );


        const isCartRequest =
          url.includes(
            '/cart/add'
          ) ||
          url.includes(
            '/cart/change'
          ) ||
          url.includes(
            '/cart/update'
          );


        /*
         * Avoid reacting unnecessarily
         * to the surcharge's own ADD request.
         */

        let body = '';

        if (
          args[1] &&
          args[1].body
        ) {

          body =
            String(
              args[1].body
            );

        }


        const isSurchargeAddRequest =
          url.includes(
            '/cart/add'
          ) &&
          body.includes(
            String(
              SURCHARGE_VARIANT_ID
            )
          );


        if (
          isCartRequest &&
          !isSurchargeAddRequest
        ) {

          scheduleSync(150);

        }


      } catch (error) {

        /*
         * Never interrupt Ella's normal
         * cart behaviour.
         */

      }


      return response;

    };


  /* =========================================================
     BLOCK MANUAL SURCHARGE CHANGES

     Even if Ella briefly renders the controls before
     we hide them, they won't work.
  ========================================================= */

  document.addEventListener(
    'click',
    function (event) {


      /*
       * REMOVE BUTTON
       */

      const removeButton =
        event.target.closest(
          '[data-cart-remove-id="' +
          SURCHARGE_VARIANT_ID +
          '"]'
        );


      if (removeButton) {

        event.preventDefault();

        event.stopPropagation();

        event.stopImmediatePropagation();

        return false;

      }


      /*
       * QUANTITY CONTROL
       */

      const quantityBlock =
        event.target.closest(
          'cart-update-quantity' +
          '[data-variant="' +
          SURCHARGE_VARIANT_ID +
          '"]'
        );


      if (quantityBlock) {

        event.preventDefault();

        event.stopPropagation();

        event.stopImmediatePropagation();

        return false;

      }

    },
    true
  );


  /* =========================================================
     WATCH ELLA CART HTML

     Ella rebuilds the side cart/full cart after AJAX
     changes, so we re-hide the surcharge controls whenever
     new cart HTML appears.
  ========================================================= */

  let observerTimer = null;


  const observer =
    new MutationObserver(
      function () {

        clearTimeout(
          observerTimer
        );


        observerTimer =
          setTimeout(
            lockSurchargeControls,
            50
          );

      }
    );


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

})();